var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteVictory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1647_17809)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 32,
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.0605,
    r: 31.5,
    stroke: "white",
    strokeOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1647_17809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7223 30.8026L42.7244 30.8018C42.9006 30.7307 43.0994 30.7307 43.2756 30.8018L43.2777 30.8026L50.7738 33.801C50.7743 33.8012 50.7747 33.8014 50.7752 33.8016C51.0648 33.92 51.25 34.1977 51.25 34.5C51.25 38.3136 49.6903 44.5256 43.2924 47.1953L43.2886 47.1969C43.1069 47.2739 42.8993 47.2739 42.7176 47.1969L42.7136 47.1952C36.3095 44.5254 34.75 38.3134 34.75 34.5C34.75 34.1978 34.9352 33.9201 35.2246 33.8017C35.2251 33.8015 35.2257 33.8012 35.2262 33.801L42.7223 30.8026ZM49.7103 35.5575L49.7526 35.0079L49.2407 34.8035L43.2782 32.4222L42.25 32.0116V33.1187V44.8563V46.0523L43.3267 45.5314C47.9201 43.3087 49.4552 38.8738 49.7103 35.5575ZM31.1265 29.1265C29.7669 30.4862 27.9228 31.25 26 31.25C24.0772 31.25 22.2331 30.4862 20.8735 29.1265C19.5138 27.7669 18.75 25.9228 18.75 24C18.75 22.0772 19.5138 20.2331 20.8735 18.8735C22.2331 17.5138 24.0772 16.75 26 16.75C27.9228 16.75 29.7669 17.5138 31.1265 18.8735C32.4862 20.2331 33.25 22.0772 33.25 24C33.25 25.9228 32.4862 27.7669 31.1265 29.1265ZM12.75 46.1437C12.75 40.4017 17.4017 35.75 23.1438 35.75H23.15H28.8625C29.711 35.75 30.5335 35.8494 31.3207 36.0408C31.6049 39.3812 32.879 43.8654 36.437 47.25H13.8563C13.2455 47.25 12.75 46.7545 12.75 46.1437Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1647_17809",
    x: -3.6,
    y: -3.53945,
    width: 71.2,
    height: 71.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1647_17809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1647_17809",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1647_17809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVictory);
export default __webpack_public_path__ + "static/media/white_victory.05fae1cc6a2e6546648155ab6841b3b6.svg";
export { ForwardRef as ReactComponent };